(function () {

  const PA_VARIANT_PROP = '_pre_assembly_variantId';
  const BASEPLATE_PROP  = '_baseplate_count';
  let isProcessing      = false;

  // ── Quick DOM check before making any network requests ──
  function cartHasPreAssembly() {
    return document.querySelector('.pa-guardian-note') !== null;
  }

  function disableCheckout() {
    document.querySelectorAll('[name="checkout"], a[href="/checkout"]').forEach(btn => {
      btn.setAttribute('disabled', 'disabled');
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.5';
    });
  }

  function enableCheckout() {
    document.querySelectorAll('[name="checkout"], a[href="/checkout"]').forEach(btn => {
      btn.removeAttribute('disabled');
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
    });
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function calculateCorrectServiceQty(cartItems, serviceVariantId) {
    let total = 0;
    cartItems.forEach(item => {
      const linkedVariant  = item.properties && item.properties[PA_VARIANT_PROP];
      const baseplateCount = item.properties && item.properties[BASEPLATE_PROP];
      if (
        linkedVariant &&
        String(linkedVariant) === String(serviceVariantId) &&
        baseplateCount
      ) {
        total += Number(baseplateCount) * item.quantity;
      }
    });
    return total;
  }

  async function enforceServiceQtys() {
    if (isProcessing) return;

    // No pre-assembly in cart — skip entirely, no network call needed
    if (!cartHasPreAssembly()) return;

    isProcessing = true;
    disableCheckout();

    try {
      const cart = await getCart();
      if (!cart.items || cart.items.length === 0) {
        enableCheckout();
        return;
      }

      const corrections = [];
      cart.items.forEach(item => {
        const selfMarker = item.properties && item.properties[PA_VARIANT_PROP];
        if (!selfMarker || String(selfMarker) !== String(item.variant_id)) return;

        const correctQty = calculateCorrectServiceQty(cart.items, item.variant_id);
        if (item.quantity !== correctQty) {
          corrections.push({ lineKey: item.key, correctQty });
        }
      });

      if (corrections.length === 0) {
        enableCheckout();
        return;
      }

      for (const { lineKey, correctQty } of corrections) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: correctQty })
        }).then(r => r.json());
      }

      window.location.reload();

    } catch (e) {
      console.error('BrickMe guardian: failed to correct service qty', e);
      enableCheckout();
    } finally {
      isProcessing = false;
    }
  }

  if (typeof subscribe === 'function') {
    subscribe('cart-update', () => {
      enforceServiceQtys();
    });
  }

  setTimeout(enforceServiceQtys, 300);

})();